/* ============================================================
   Izzie's Bikinies — gentle scroll reveal (Step 2, hardened Step 10)
   One reusable utility for the whole theme.

   Usage:
     <div data-reveal> ... </div>                 // fades + rises once in view
     <ul data-reveal-stagger="100">               // staggers direct children
       <li data-reveal>...</li>                    // (each child needs data-reveal)
       <li data-reveal>...</li>
     </ul>

   Motion: opacity 0->1, translateY(20px)->0, 800ms,
   cubic-bezier(0.16,1,0.3,1). Triggers at ~15% in view, runs once.
   Honors prefers-reduced-motion (shows everything, no transforms).

   Step 10: a MutationObserver also watches for [data-reveal] elements
   added later by AJAX (collection filters, infinite scroll, quick views),
   so dynamically-injected content never stays stuck hidden.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealNow(el) {
    el.classList.add('is-revealed');
  }

  // No observer / reduced motion -> just show everything (now and later).
  if (reduceMotion || !('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-reveal]').forEach(revealNow);
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('[data-reveal]')) revealNow(node);
            if (node.querySelectorAll) node.querySelectorAll('[data-reveal]').forEach(revealNow);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target); // run once
        }
      });
    },
    { threshold: 0.15 }
  );

  function applyStagger(group) {
    var step = parseInt(group.getAttribute('data-reveal-stagger'), 10);
    if (isNaN(step)) step = 100; // ms — within the gentle 80–120ms band
    group.querySelectorAll(':scope > [data-reveal]').forEach(function (child, index) {
      child.style.transitionDelay = index * step + 'ms';
    });
  }

  function register(root) {
    // Assign stagger delays to any new groups inside `root`.
    if (root.matches && root.matches('[data-reveal-stagger]')) applyStagger(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-reveal-stagger]').forEach(applyStagger);
    }
    // Observe any not-yet-revealed reveal targets.
    var targets = [];
    if (root.matches && root.matches('[data-reveal]')) targets.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function (el) {
        targets.push(el);
      });
    }
    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  register(document);

  // Watch for AJAX-injected content (filters, pagination, etc.)
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) register(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
